module.exports = __webpack_public_path__ + "img/healthy_page02_img.da624124.png";